import { forwardRef, type ButtonHTMLAttributes, type AnchorHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

type Variant = 'primary' | 'ghost';

const BASE_CLASS =
  'inline-flex items-center gap-2 rounded-full border border-transparent px-[18px] py-[11px] text-body font-medium transition-[background,transform,box-shadow,border-color] duration-150 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100';

const VARIANT_CLASS: Record<Variant, string> = {
  primary:
    'bg-stevens-indigo-solid text-stevens-indigo-solid-fg hover:bg-stevens-indigo-solid-2',
  ghost:
    'border-stevens-rule bg-transparent text-stevens-ink hover:bg-stevens-bg-2 hover:border-stevens-ink-3',
};

interface PillButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

export const PillButton = forwardRef<HTMLButtonElement, PillButtonProps>(function PillButton(
  { variant = 'primary', className, children, ...rest },
  ref,
) {
  return (
    <button ref={ref} className={cn(BASE_CLASS, VARIANT_CLASS[variant], className)} {...rest}>
      {children}
    </button>
  );
});

interface PillLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: Variant;
}

export const PillLink = forwardRef<HTMLAnchorElement, PillLinkProps>(function PillLink(
  { variant = 'primary', className, children, ...rest },
  ref,
) {
  return (
    <a ref={ref} className={cn(BASE_CLASS, VARIANT_CLASS[variant], className)} {...rest}>
      {children}
    </a>
  );
});
